module.exports = __webpack_public_path__ + "fonts/TitilliumWeb-Light.edc21ba.ttf";